import { Component, OnDestroy, OnInit } from '@angular/core';
import { CheckoutDeliveryAddressFacade } from '@spartacus/checkout/base/root';
import {
  Address,
  GlobalMessageService,
  PageMetaService,
  TranslationService, UserIdService
} from '@spartacus/core';
import { AddressBookComponent, AddressBookComponentService } from '@spartacus/user/profile/components';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { firstnameLastnameFormatter } from '../../../../../../custom/formatter/firstname-lastname-formatter';
import { ICON_TYPE } from '../../../../../../custom/icons/icon.model';
import { CustomUserAddressService } from '../../../../../custom/core/user/facade/profile/custom-user-address.service';
import { CustomAddressBookComponentService } from './custom-address-book.component.service';

@Component({
  selector: 'app-custom-address-book',
  templateUrl: './custom-address-book.component.html',
  standalone: false
})
export class CustomAddressBookComponent extends AddressBookComponent implements OnInit, OnDestroy {
  iconTypes = ICON_TYPE;
  pageTitle: string;
  pageDescription: string;
  protected subscriptions: Subscription = new Subscription();

  constructor(
    public service: AddressBookComponentService,
    protected translation: TranslationService,
    protected globalMessageService: GlobalMessageService,
    protected checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    protected pageMetaService: PageMetaService,
    protected userIdService: UserIdService,
    protected customAddressService: CustomUserAddressService,
    protected customAddressBookComponentService: CustomAddressBookComponentService,
  ) {
    super(service, translation, globalMessageService);
  }

  editAddressButtonHandle(address: Address): void {
    this.showAddAddressForm = false;
    this.showEditAddressForm = true;
    this.currentAddress = address;
  }


  ngOnInit(): void {
    this.subscriptions.add(
      this.pageMetaService.getMeta().subscribe(
        data => {
          this.pageTitle = data.title;
          this.pageDescription = data.description;
        },
      ),
    );

    this.addresses$ = this.service.getAddresses();
    this.addressesStateLoading$ = this.service.getAddressesStateLoading();
    this.service.loadAddresses();
  }

  addAddressSubmit(address: Address): void {
    if (address.region.isocode !== null) {
      this.showAddAddressForm = false;
      this.customAddressBookComponentService.addUserAddress(address);
    }
  }

  editAddressSubmit(address: Address): void {
    this.showEditAddressForm = false;
    this.service.updateUserAddress(this.currentAddress['id'], address);
  }

  customSetAddressAsDefault(addressId: string, address: Address): void {
    const customAddress = JSON.parse(JSON.stringify(address));
    customAddress.defaultAddress = true;
    this.customAddressService.customSetAddressAsDefault(addressId, customAddress);
  }

  selectAddress(address: Address): void {
    this.checkoutDeliveryAddressFacade.setDeliveryAddress(address);

  }

  getCardContent(address: Address): Observable<{
    textBold: string; text: string[];
    actions: { name: string; event: string; }[];
    header: string; deleteMsg: string;
  }> {
    return combineLatest([
      this.translation.translate('addressCard.default'),
      this.translation.translate('addressCard.setAsDefault'),
      this.translation.translate('common.remove'),
      this.translation.translate('common.edit'),
      this.translation.translate('addressBook.areYouSureToDeleteAddress'),
    ]).pipe(
      map(
        ([
           defaultText,
           setAsDefaultText,
           textDelete,
           textEdit,
           textVerifyDeleteMsg,
         ]) => {
          let region = '';

          if (address.region && address.region.isocode) {
            region = address.region.isocode + ', ';
          }

          const actions: { name: string; event: string }[] = [];
          if (!address.defaultAddress) {
            actions.push({ name: setAsDefaultText, event: 'default' });
          } else {
            actions.push({ name: defaultText, event: 'isDefault' });
          }
          actions.push({ name: textEdit, event: 'edit' });
          actions.push({ name: textDelete, event: 'delete' });

          return {
            textBold: firstnameLastnameFormatter(address),
            text: [
              address.line1 + ' ' + address.line2 + ' ' + address.town,
              region + address.postalCode
              // address.phone,
            ],
            actions,
            header: address.defaultAddress ? `✓ ${defaultText}` : '',
            deleteMsg: textVerifyDeleteMsg,
          };
        },
      ),
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
